import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { Link, navigate } from 'gatsby';
import { useLocation } from '@reach/router';

export const TransitionLink = ({ to, children, delay }) => {

    const { pathname } = useLocation();

    const [transitioning, setTransitioning] = useState(false);
    const [transitioned, setTransitioned] = useState(true);

    const timer = useRef(null);

    useEffect(() => {
        timer.current = setTimeout(() => {
            setTransitioned(true);
        }, 250);

        return () => {
            setTransitioning(false);
            clearTimeout(timer.current);
        };
    }, [pathname]);

    const onClickHandler = (e) => {
        e.preventDefault();
        clearTimeout(timer.current);

        if (to !== pathname) {
            setTransitioning(true);
            setTransitioned(false);

            timer.current = setTimeout(() => {
                navigate(to);
            }, 250);
        };
    };

    return (
        <>
            {!transitioned &&
                <div
                    className={`fixed w-[5000px] h-[5000px] -left-[100vw] -bottom-[100vh] bg-surface z-[-1] pointer-events-none ${transitioning ? 'animate-page-fade-in opacity-100' : 'animate-page-fade-out opacity-0'}`}
                />
            }
            <Link
                to={to}
                onClick={e => onClickHandler(e)}
                className="nav-link relative transition-all duration-100 ease-out font-display text-on-surface no-underline m-auto"
                style={{ animationDelay: `${0.4 + delay}s` }}
            >
                {children}
            </Link>
        </>
    );
};
